"use strict";

const authService = angular.module("authService",
    ["classy", "schoolSubcategoriesModel", "accountModel", "ipCookie", "messageModel"]
);

authService.classy.controller({
    name: "SchoolSelectController",
    inject: [
        "$scope",
        "$modal",
        "authServiceFactory",
        "SchoolSubcategoriesModelService",
        "AccountModelService",
        "PermissionModelService",
        "SchoolModelService"
    ],
    init: function() {
        this.$.userdata = this.authServiceFactory.temp[0].data;
    },
    setSchool: function(schoolinfo) {
        this.$.userdata.schoolID = schoolinfo.schoolID;
        this.PermissionModelService.set(this.$.userdata.permissions);
        this.$.userdata.login = schoolinfo.login;
        this.$.userdata.oldToken = schoolinfo.hash1 + schoolinfo.hash2 + schoolinfo.hash3;
        this.$.userdata.committee_mode = [];
        this.$.userdata.committee_mode[0] = {
            active: 0,
            anon: 1,
            filter: "",
            leader: 1,
            schoolID: schoolinfo.schoolID,
            startDate: "0000-00-00",
            startTime: "00:00:00",
            taxTab: 1
        };
        delete this.$.userdata.userSchools;
        this.authServiceFactory.set(this.$.userdata);
        this.authServiceFactory.deferred.resolve(this.authServiceFactory.temp);
        this.$modal.$close();
    }
});

authService.factory("authServiceFactory", function(
    $http, $modal, $location, $cookieStore, $cookies, $q, $timeout,
    SchoolSubcategoriesModelService, AccountModelService, ipCookie, UserSchoolModelService, MessageModelService,
    CommitteeModeModelService, PermissionModelService) {
    this.unlocked = 1;
    this.isHTTPS = $location.protocol() === "https";
    this.setToken = function(data) {
        $http.defaults.headers.common["auth-token"] = data.token;
    };

    this.set = function(data) {
        let deferred = $q.defer();
        this.setToken(data);
        ipCookie("auth", data, {secure: this.isHTTPS});
        this.auth = data;
        this.mimicV3(data);
        $timeout(() => {
            deferred.resolve();
        }, 200);
        return deferred.promise;
    };

    this.mimicV3 = function(data) {
        // fix for viewing taxes
        // if there is no v3 user, set the user string so it passes validation when retrieving taxes
        const login = data.login ? data.login : "taxuser";
        let domain = "." + this.getDomain();

        ipCookie("schoolcookie", data.schoolID + " " + login, {domain: domain, secure: true});
        ipCookie("stan", data.schoolID, {domain: domain, secure: true});
        ipCookie("r1", data.oldToken.substr(0, 32), {domain: domain, secure: true});
        ipCookie("s2", data.oldToken.substr(32, 32), {domain: domain, secure: true});
        ipCookie("t3", data.oldToken.substr(64, 32), {domain: domain, secure: true});
    };

    this.load = function(data) {
        let config = {};
        data.login = 1;
        if ($location.$$absUrl.split("?").length !== 1) {
            data.ismToken = $location.$$absUrl.split("?")[1].split("=")[1];
        }
        config.headers = data;
        $cookieStore.remove("filter");
        let deferred = $q.defer();
        $q.all(
            [$http.get("/api/user", config)]
        ).then((results) => {
            this.temp = results;
            if (results[0].data.userSchools !== undefined) {
                this.schoolSelect();
            } else {
                PermissionModelService.set(results[0].data.permissions);
                CommitteeModeModelService.set(results[0].data.committee_mode);
                delete results[0].data.subcategory;
                delete results[0].data.accounts;
                delete results[0].data.messages;
                delete results[0].data.userSchools;
                this.set(results[0].data).then(() => {
                    deferred.resolve(results);
                });
            }
        }, (results) => {
            deferred.resolve(results);
        });
        return deferred.promise;
    };

    this.loadV3 = function(data) {
        $cookieStore.remove("filter");

        data.login = 1;
        if ($location.$$absUrl.split("?").length !== 1) {
            data.ismToken = $location.$$absUrl.split("?")[1].split("=")[1];
        }
        let config = {headers: data};

        let deferred = $q.defer();
        $q.all([$http.get("/api/userV3", config)]).then((results) => {
            if (!results[0].data[0]) {
                results[0].status = 401;
            }
            deferred.resolve(results);
        }, (results) => {
            deferred.resolve(results);
        });
        return deferred.promise;
    };

    this.schoolSelect = function() {
        $modal.open({
            templateUrl: "fast/services/authService/schoolSelectModal.html",
            controller: "SchoolSelectController"
        });
    };

    this.check = function() {
        if (typeof $cookieStore.get("auth") !== "undefined") {
            this.setToken($cookieStore.get("auth"));
            return true;
        } else {
            if (this.auth && this.auth.isISMon) {
                window.location = "#?ismToken=" + this.auth.ismToken;
            } else {
                window.location = "/";
            }
        }
        return false;
    };

    this.getAuth = function() {
        if (typeof this.auth === "undefined") {
            this.auth = $cookieStore.get("auth");
        }
        this.check();
        return this.auth;
    };

    this.logout = function() {
        $cookieStore.remove("auth");
        this.check();
    };

    this.isFollower = function() {
        if (typeof this.auth.committee_mode[0] === "undefined") {
            return false;
        }
        return this.auth.loginType === "COMMITTEE" && this.auth.committee_mode[0].leader === 1;
    };

    this.isLeader = function() {
        if (typeof this.auth.committee_mode[0] === "undefined") {
            return true;
        }
        return this.auth.loginType === "USER";
    };

    this.sendResetEmail = function(emailObj) {
        return $http.post("/api/ForgotPassword", emailObj);
    };

    this.resetPassword = function(resetObj) {
        return $http.post("/api/ResetPassword", resetObj);
    };

    this.getVersion = function(token) {
        return $http.get(`/api/ResetPassword/${token}`);
    };

    this.getDomain = function() {
        if (window.location.host.indexOf(".com") !== -1) {
            return "ismfast.com";
        } else if (window.location.host.indexOf(".net") !== -1) {
            return "ismfast.net";
        } else if (window.location.host.indexOf("localhost") !== -1) {
            return window.location.host;
        }
    };

    return this;
});
